// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const PaymentRefundStatus = {
  Pending: {
    Name: 'Pending',
    Value: 'pending',
  },
  Processing: {
    Name: 'Processing',
    Value: 'processing',
  },
  Succeeded: {
    Name: 'Succeeded',
    Value: 'succeeded',
  },
  Failed: {
    Name: 'Failed',
    Value: 'failed',
  },
  CashPendingConfirmation: {
    Name: 'Cash Pending Confirmation',
    Value: 'cash_pending_confirmation',
  },
  CashConfirmed: {
    Name: 'Cash Confirmed',
    Value: 'cash_confirmed',
  },
  Canceled: {
    Name: 'Canceled',
    Value: 'canceled',
  },
} as const

export type PaymentRefundStatusValue =
  (typeof PaymentRefundStatus)[keyof typeof PaymentRefundStatus]['Value']
